import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LOCATION_FEATURE } from './actions/location.actions';
import { LocationEffects } from './effects/location.effect';
import { locationReducers } from './reducers/location.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(LOCATION_FEATURE, locationReducers),
    EffectsModule.forFeature([ LocationEffects ]),
  ],
})
export class LocationStoreModule {}
